import { render, staticRenderFns } from "./AllBranches.vue?vue&type=template&id=5503c446&scoped=true"
import script from "./AllBranches.vue?vue&type=script&lang=js"
export * from "./AllBranches.vue?vue&type=script&lang=js"
import style0 from "./AllBranches.vue?vue&type=style&index=0&id=5503c446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5503c446",
  null
  
)

export default component.exports